export const SAFE_PDF_RECORDS_NUMBER = 5000;
export const SAFE_PDF_ROWS_PER_DOC_NUMBER = 1000;
